import { ReparoApi } from './index';

export type ChannelFulfillmentMode = 'PUSH' | 'PO_DRIVEN';
/** Who raises orders on a channel: the partner (a sales order) or the brand (a shipment). */
export type ChannelOrderOrigin = 'PARTNER' | 'BRAND';
/** Where a channel's in-transit figure comes from. */
export type ChannelInTransitSource = 'COMPUTED' | 'CHANNEL_SYSTEM' | 'CHANNEL_STOCK_FEED';

export interface ChannelFulfillmentModeEntry {
    channelAbbreviationKey: string;
    fulfillmentMode: ChannelFulfillmentMode;
    poActionSlaHours: number;
    orderOrigin?: ChannelOrderOrigin | null;
    inTransitSource?: ChannelInTransitSource;
    leadTimeWindowDays?: number;
}

/** Fulfilment mode (PUSH / PO_DRIVEN) per channel abbreviation key. */
export const getChannelFulfillmentModes = async (): Promise<ChannelFulfillmentModeEntry[]> => {
    return ReparoApi<any>({
        method: 'GET',
        url: '/channels/fulfillment-modes',
    });
};

export const setChannelFulfillmentMode = async (
    abbreviationKey: string,
    updates: {
        fulfillmentMode?: ChannelFulfillmentMode;
        poActionSlaHours?: number;
        orderOrigin?: ChannelOrderOrigin | null;
        inTransitSource?: ChannelInTransitSource;
        leadTimeWindowDays?: number;
    },
): Promise<ChannelFulfillmentModeEntry> => {
    return ReparoApi<any>({
        method: 'PUT',
        url: `/channels/fulfillment-modes/${encodeURIComponent(abbreviationKey)}`,
        body: JSON.stringify(updates),
    });
};

export interface ChannelRow {
    channelId: string;
    name: string;
    type?: string | null;
    model?: string | null;
    abbreviationKey?: string | null;
}

/** The brand's channel rows (one row per WMS channel name; several can share a key). */
export const listChannels = async (): Promise<ChannelRow[]> =>
    (await ReparoApi<ChannelRow[] | null>({ method: 'GET', url: '/channels?limit=500' })) ?? [];
